var e = ["mon", "tue", "wed", "thu", "fri", "sat", "sun"],
    t = [6, 0, 1, 2, 3, 4, 5];
export { t as weekIndexMap, e as weeksMap };